import { useLocation } from 'react-router-dom';
import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const {
        setAuth,
        getTenantIdFromUrl,
        tenantSessions,
        setAuthWithTenant,
        getTenantIdFromConsentUrl,
        currentTenant
    } = useAuth();
    const { pathname } = useLocation()

    const refresh = async () => {
        const lastTenantSession = tenantSessions[tenantSessions.length - 1];
        const urlTenantId = getTenantIdFromUrl();
        let tenantId = "";

        const sanitizeTenantId = (value) => {
            if (value === undefined || value === null) return "";
            const normalized = String(value).trim();
            if (!normalized || normalized === "null" || normalized === "undefined") {
                return "";
            }
            return normalized;
        };
        
        // For auth flows (consent/login/register), prioritize URL tenant to handle cross-tenant scenarios
        if (pathname.includes("consent")) {
            tenantId = getTenantIdFromConsentUrl();
        } else if (pathname.includes("login") || pathname.includes("register")) {
            // On login/register pages, prioritize URL tenant over session tenant
            // This handles the case where user is logging into a different tenant
            tenantId = urlTenantId || currentTenant?.id || lastTenantSession?.tenant_id;
            console.log("useRefreshToken on auth page - using URL tenant:", urlTenantId, "fallback:", currentTenant?.id || lastTenantSession?.tenant_id);
        } else {
            // For other pages, use session tenant first, then URL
            tenantId = currentTenant?.id || lastTenantSession?.tenant_id || urlTenantId;
        }
        tenantId = sanitizeTenantId(tenantId);
        console.log("useRefreshToken: Refreshing token for tenantId:", tenantId);
        
        try {
            const refreshPath = tenantId
                ? `/refreshToken?tenant_id=${encodeURIComponent(tenantId)}`
                : "/refreshToken";
            const response = await axios.get(refreshPath, {
                withCredentials: true,
            });

            const authData = response.data.data;

            if (tenantId) {
                // Use the new multi-tenant auth setter
                setAuthWithTenant(authData, tenantId);
            } else {
                // Fallback to legacy behavior
                setAuth(prev => {
                    prev = authData;
                    return prev;
                });
            }

            return authData.access_token;
        } catch (error) {
            // For consent flows, re-throw the error to let consentRoute handle it
            if (pathname.includes("consent")) {
                console.log("RefreshToken failed for consent flow - tenant mismatch expected");
                throw error;
            }
            // For other flows, also re-throw to maintain existing behavior
            throw error;
        }
    }
    return refresh;
};

export default useRefreshToken;
